export default __webpack_public_path__ + "static/media/cc-task-comment.4b8b5784.jpg";